var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLine9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#line-9_svg__a)",
  fillOpacity: 0.64,
  d: "M.572 3.505a.495.495 0 0 0 0 .99v-.99Zm21.138.845a.495.495 0 0 0 0-.7L18.56.5a.495.495 0 0 0-.7.7l2.8 2.8-2.8 2.8a.495.495 0 1 0 .7.7l3.15-3.15ZM.572 4.495H21.36v-.99H.572v.99Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "line-9_svg__a",
  x1: 21.36,
  x2: 0.572,
  y1: 4,
  y2: 4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.16
})))));
export default SvgLine9;